// main.tsx
import { CssBaseline, ThemeProvider } from '@mui/material';
import { GlobalStyles } from '@mui/system';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { CSIRouter } from './CSIRouter.tsx';
import './index.css';
import { SiteStyles } from './theme/styles.ts';
import { theme } from './theme/theme.ts';

function createQueryClient() {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 5 * 60 * 1000, // 5 minutes - data stays fresh longer
        gcTime: 10 * 60 * 1000, // 10 minutes - keep unused data in cache longer
        refetchOnWindowFocus: false, // Don't auto-refetch when window regains focus
        retry: 1, // Retry failed requests once
      },
    },
  });
}

// Preserve QueryClient across HMR to prevent auth state loss
let queryClient: QueryClient;
if (import.meta.hot) {
  // In dev, store on the HMR context so it survives module re-evaluation
  if (!import.meta.hot.data.queryClient) {
    import.meta.hot.data.queryClient = createQueryClient();
  }
  queryClient = import.meta.hot.data.queryClient;
  import.meta.hot.accept();
} else {
  queryClient = createQueryClient();
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <QueryClientProvider client={queryClient}>
        <CssBaseline />
        <GlobalStyles styles={SiteStyles} />
        <RouterProvider
          router={CSIRouter}
          future={{ v7_startTransition: true }}
        />
      </QueryClientProvider>
    </ThemeProvider>
  </StrictMode>,
);
